import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { P11, P11_LOGO } from "./p11shared";
import { useP11Role } from "./P11AdminGuard";

const NAV = [
  { to: "/project11/admin", label: "TODAY", id: "today", end: true },
  { to: "/project11/admin/overview", label: "OVERVIEW", id: "overview" },
  { to: "/project11/admin/participants", label: "PARTICIPANTS", id: "participants" },
  { to: "/project11/admin/sessions", label: "SESSIONS", id: "sessions" },
  { to: "/project11/admin/numbers", label: "IDENTIFICATION", id: "numbers" },
  { to: "/project11/admin/project", label: "PROJECT", id: "project" },
  { to: "/project11/admin/notifications", label: "NOTIFICATIONS", id: "notifications" },
  { to: "/project11/admin/settings", label: "SETTINGS", id: "settings" },
];

export default function P11AdminLayout({ children }) {
  const role = useP11Role();
  const [open, setOpen] = useState(false);
  const links = (
    <>
      {NAV.map((n) => (
        <NavLink key={n.id} to={n.to} end={n.end} onClick={() => setOpen(false)} data-testid={`p11-admin-nav-${n.id}`}
          className={({ isActive }) => `p11-label block px-3 py-2.5 border-l-2 transition-colors ${isActive ? "text-[#FFE44D] border-[#FFE44D]" : "text-[#858585] border-transparent hover:text-white"}`}>
          {n.label}
        </NavLink>
      ))}
    </>
  );
  return (
    <div className="p11-root min-h-screen flex" data-testid="p11-admin-layout">
      <aside className="hidden md:flex flex-col w-56 shrink-0 border-r py-6 px-4" style={{ borderColor: P11.border }}>
        <img src={P11_LOGO} alt="Project 11*" className="h-6 object-contain self-start mb-1" />
        <div className="p11-label mb-8">ADMIN — {role.toUpperCase()}</div>
        {links}
        <a href="/admin" className="p11-label px-3 py-2.5 mt-auto text-[#858585] hover:text-white transition-colors" data-testid="p11-admin-back-joh">← JOH. ADMIN</a>
      </aside>
      <div className="md:hidden fixed top-0 left-0 right-0 z-40 flex items-center justify-between px-5 py-4 border-b bg-[#080808]" style={{ borderColor: P11.border }}>
        <img src={P11_LOGO} alt="Project 11*" className="h-5 object-contain" />
        <button onClick={() => setOpen(!open)} className="p11-label" data-testid="p11-admin-menu">{open ? <X size={18}/> : <Menu size={18}/>}</button>
      </div>
      {open && (
        <div className="md:hidden fixed inset-0 z-30 bg-[#080808] pt-16 px-6" data-testid="p11-admin-drawer">{links}
          <a href="/admin" className="p11-label block px-3 py-2.5 text-[#858585]" data-testid="p11-admin-back-joh-m">← JOH. ADMIN</a>
        </div>
      )}
      <main className="flex-1 min-w-0 px-5 md:px-10 py-8 pt-20 md:pt-8 max-w-5xl">{children}</main>
    </div>
  );
}
